// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_93444fe79c--wrapper--IrfC9","desktop-card":"_93444fe79c--desktop-card--b5KSz"};